<template>
	<div id="top">
		<van-nav-bar
			:title="label"
			left-arrow
			right-text="回首页"
			@click-right="toMaintainFund"
			@click-left="toPrevPage"
		/>
		<van-image
			style="width: 100vw"
			:src="mainImgUrlList"
		/>
	</div>
</template>

<script>
	import {NavBar} from 'vant'
	export default {
		name: "Top",
		components: {
			VanNavBar: NavBar
		},
		data() {
			return {
				label: decodeURI(this.$route.query.label),
				mainImgUrlList: require("@/assets/small-logo.png")
			}
		},
		methods: {
			toPrevPage() {
				this.$router.go(-1);
			},
			toMaintainFund() {
				this.$router.push({path: '/maintainFund'})
			}
		}
	}
</script>
<style></style>